// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"d4a639b0","626":"1a5b815b"}[chunkId] + ".chunk.js";
};